import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: { // Exercise num
    unit: 'Unit 5',
    id: 'WB4-V2-U5-P36-E1',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    maxLength: 1,
    textAlign: 'center',
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page36/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page36/E1/1.jpg' },
      ],
      [
        // Column2 neighbor
        { url: 'img/FriendsPlus/Page36/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page36/E1/3.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page36/E1/4.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page36/E1/5.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page36/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page36/E1/7.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page36/E1/8.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page36/E1/9.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page36/E1/10.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page36/E1/11.jpg', input: true, answer: "h" },
        { url: 'img/FriendsPlus/Page36/E1/12.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page36/E1/13.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page36/E1/14.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page36/E1/15.jpg' },
      ],

    ]
  },
  2: { // Exercise num
    unit: 'Unit 5',
    id: 'WB4-V2-U5-P36-E2',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page36/E2/Key/answerKey.png',
    textAlign: 'center',
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page36/E2/1.jpg' },
      ],
      [
        // Column2     tie
        { url: 'img/FriendsPlus/Page36/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page36/E2/3.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page36/E2/4.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page36/E2/5.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page36/E2/6.jpg' },
      ],
      [
        // Column4    neighbor
        { url: 'img/FriendsPlus/Page36/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page36/E2/8.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page36/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page36/E2/10.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page36/E2/11.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page36/E2/12.jpg', input: true, answer: "h" },
        { url: 'img/FriendsPlus/Page36/E2/13.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page36/E2/14.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page36/E2/15.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page36/E2/16.jpg' },
      ],
      [
        // Column5 candy
        { url: 'img/FriendsPlus/Page36/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page36/E2/18.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page36/E2/19.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page36/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page36/E2/21.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page36/E2/22.jpg', input: true, answer: "y" },
        { url: 'img/FriendsPlus/Page36/E2/23.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page36/E2/24.jpg' },
      ],
      [
        // Column7   nuts
        { url: 'img/FriendsPlus/Page36/E2/25.jpg' },
        { url: 'img/FriendsPlus/Page36/E2/26.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page36/E2/27.jpg', input: true, answer: "u" },
        { url: 'img/FriendsPlus/Page36/E2/28.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page36/E2/29.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page36/E2/30.jpg' },
      ],
      [
        // Column9   b a l l o o n
        { url: 'img/FriendsPlus/Page36/E2/31.jpg' },
        { url: 'img/FriendsPlus/Page36/E2/32.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page36/E2/33.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page36/E2/34.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page36/E2/35.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page36/E2/36.jpg' },
        { url: 'img/FriendsPlus/Page36/E2/37.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page36/E2/38.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page36/E2/39.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page36/E2/40.jpg' },
      ],
      [
        // Column11   cake
        { url: 'img/FriendsPlus/Page36/E2/41.jpg' },
        { url: 'img/FriendsPlus/Page36/E2/42.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page36/E2/43.jpg' },
        { url: 'img/FriendsPlus/Page36/E2/44.jpg', input: true, answer: "k" },
        { url: 'img/FriendsPlus/Page36/E2/45.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page36/E2/46.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page36/E2/47.jpg' },
      ],




    ],
  },



}

export default json;